var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-outer-div"},[_c('div',{staticClass:"detail-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"detail-time"},[_vm._v(" "+_vm._s(_vm._f("datefull")(_vm.time)))]),_c('div',{staticClass:"detail-content"},[_vm._v(" "+_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }